export const language = $('input#_language').val();

export const propertyLanguage = $('input#_property_language')
  .val()
  ?.replace('_', '-');
